import { render, staticRenderFns } from "./TaxPeriod.vue?vue&type=template&id=263ca07a"
import script from "./TaxPeriod.vue?vue&type=script&lang=js"
export * from "./TaxPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports